import { render, staticRenderFns } from "./simpleMultiselect.vue?vue&type=template&id=bdaf4db4&scoped=true"
import script from "./simpleMultiselect.vue?vue&type=script&lang=js"
export * from "./simpleMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf4db4",
  null
  
)

export default component.exports